import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Drawer from '../../../../components/Drawer/Drawer';
import { reset } from '../../../../stores/NewConnectionStore';
import NewUserCreateUserStep from './NewUserCreateUserStep';

interface NewUserDrawerProps {
  open: boolean;
  onClose: () => void;
  onNewUserSuccess: () => void;
}
function NewUserDrawer({ open, onClose, onNewUserSuccess }: NewUserDrawerProps) {
  const dispatch = useDispatch();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    dispatch(reset());
    onClose();
  };

  const [t] = useTranslation();

  return (
    <Drawer
      disablePortal
      open={open}
      onClose={handleClose}
      onBackButton={handleClose}
      anchor="right"
      title={t('pages.eSimManager.newUserDrawer.title')}
      progress={100}
    >
      <Box sx={{ paddingTop: '2rem', height: '100%' }}>
        <NewUserCreateUserStep onClose={handleClose} onNewUserSuccess={onNewUserSuccess} />
      </Box>
    </Drawer>
  );
}

export default NewUserDrawer;
